import React, { useState } from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/material/styles";
import { alpha, Box } from "@mui/material";

import AppLabel from "./AppLabel";

const SelectBox = styled(Select)(({ theme }) => {
  return {
    cursor: "pointer",
    fontSize: 14,
    height: 24,
    borderColor: "lightgrey",
    padding: 25,
    "& .MuiSelect-select": {
      paddingLeft: 5,
      paddingTop: 1,
      paddingBottom: 3,
      color: "text.secondary",
      borderColor: "grey",
    },
    "& .MuiSelect-icon": {
      color: "text.secondary",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "grey",
    },
    "&:hover": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "grey",
      },
    },
    "&.Mui-focused": {
      backgroundColor: alpha(theme.palette.common.black, 0.03),
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "grey",
      },
    },
  };
});

interface AppSelectProps {
  options: any[];
  onChange: (e: any) => void;
  defaultValue?: any;
  selectionKey?: string;
  label?: string;
  name: string;
  isRequired?: boolean;
  errText?: string;
  theme?: "dark" | "light";
}

const AppSelectField: React.FC<AppSelectProps> = (props) => {
  const {
    options = [],
    onChange,
    defaultValue = "",
    selectionKey = "",
    label,
    name,
    isRequired = false,
    theme = "light",
  } = props;

  const [selectionType, setSelectionType] = useState<string>(defaultValue);

  const handleSelectionType = (value: string) => {
    setSelectionType(value);
    onChange(value);
  };

  return (
    <>
      <Box sx={{ marginBottom: "10px" }}>
        <AppLabel htmlFor={name} color={theme === "dark" ? "white" : "black"}>
          {label}
          {isRequired && <span className="text-danger">*</span>}
        </AppLabel>
        <SelectBox
          name={name}
          defaultValue={defaultValue}
          value={selectionType}
          onChange={(event) =>
            handleSelectionType(event.target.value as string)
          }
          className="select-box"
          fullWidth
        >
          {options.map((menu, index) => (
            <MenuItem
              key={index}
              value={selectionKey ? menu[selectionKey] : menu.value}
              sx={{ cursor: "pointer", p: 2, fontSize: 14 }}
            >
              {selectionKey ? menu[selectionKey] : menu.label}
            </MenuItem>
          ))}
        </SelectBox>
      </Box>
    </>
  );
};

export default AppSelectField;
